module.exports = __webpack_public_path__ + "img/location.25b0b6b3.png";